// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".u-tooltip[data-v-2c0a17c2]{pointer-events:none;position:fixed;z-index:9999;max-width:200px;font-size:11px;background-color:#fff;padding:3px 10px;border-radius:3px;box-shadow:0 4px 20px 0 rgba(0,0,0,.15);opacity:.98;transform:translate(-50%,-120%)}.fade-enter-active[data-v-2c0a17c2],.fade-leave-active[data-v-2c0a17c2]{transition:opacity .2s}.fade-enter[data-v-2c0a17c2],.fade-leave-to[data-v-2c0a17c2]{opacity:0}", ""]);
// Exports
module.exports = exports;
